import { Typography, useTheme } from '@mui/material'
import { useContract } from '~/contexts'
import { useUserGetQuery } from '~/graphql/types'
import { formatDate } from '~/utils'

export const ActiveBy: React.FC = () => {
  const { contract } = useContract()
  const theme = useTheme()

  const { data: activateData } = useUserGetQuery({
    variables: {
      id: contract?.activatedBy || ''
    }
  })

  return (
    <>
      <Typography color={theme.palette.grey[400]} fontSize='.95rem' fontWeight={500}>Ativada em: {formatDate(contract?.activatedAt)} | por: {activateData?.userGet.name}</Typography>
    </>
  )
}
